require('slick.js/slick/slick.min');

$ ->
  $('.slider').slick
    autoplay: true
    fade: false
    speed: 500
    dots: false
    arrows: false
    autoplaySpeed: 6000

$ ->
  $('.contactslider').slick
    autoplay: true
    fade: true
    speed: 2000
    dots: false
    arrows: false
    autoplaySpeed: 5000


// WEBPACK FOOTER //
// ./Components/slider.coffee